const $ = require('jquery');

window.$ = window.jQuery = $;

window.bootstrap = require('bootstrap5/dist/js/bootstrap.min');
const Parallax = require('parallax-scroll');
require('@fancyapps/fancybox/dist/jquery.fancybox.min');
const AOS = require('aos/dist/aos');
require('bootstrap-fileinput/js/fileinput.min');
require('bootstrap-fileinput/themes/fa5/theme.min');
require('bootstrap-fileinput/js/locales/es');
require('bootstrap-fileinput/js/locales/pt');
require('jquery-validation/dist/jquery.validate.min');
const Sortable = require('sortablejs/Sortable.min');

if (typeof pageLanguage == 'undefined') {
    const pageLanguage = 'es';
}

if (pageLanguage == 'pt') {
    /*
    * Translated default messages for the jQuery validation plugin.
    * Locale: PT (Portuguese; português)
    * Region: PT (Portugal)
    */
    $.extend($.validator.messages, {
        required: "Campo de preenchimento obrigat&oacute;rio.",
        remote: "Por favor, corrija este campo.",
        email: "Por favor, introduza um endere&ccedil;o eletr&oacute;nico v&aacute;lido.",
        url: "Por favor, introduza um URL v&aacute;lido.",
        date: "Por favor, introduza uma data v&aacute;lida.",
        dateISO: "Por favor, introduza uma data v&aacute;lida (ISO).",
        number: "Por favor, introduza um n&uacute;mero v&aacute;lido.",
        digits: "Por favor, introduza apenas d&iacute;gitos.",
        creditcard: "Por favor, introduza um n&uacute;mero de cart&atilde;o de cr&eacute;dito v&aacute;lido.",
        equalTo: "Por favor, introduza de novo o mesmo valor.",
        extension: "Por favor, introduza um ficheiro com uma extens&atilde;o v&aacute;lida.",
        maxlength: $.validator.format("Por favor, n&atilde;o introduza mais do que {0} caracteres."),
        minlength: $.validator.format("Por favor, introduza pelo menos {0} caracteres."),
        rangelength: $.validator.format("Por favor, introduza entre {0} e {1} caracteres."),
        range: $.validator.format("Por favor, introduza um valor entre {0} e {1}."),
        max: $.validator.format("Por favor, introduza um valor menor ou igual a {0}."),
        min: $.validator.format("Por favor, introduza um valor maior ou igual a {0}."),
        nifES: "Por favor, introduza um NIF v&aacute;lido.",
        nieES: "Por favor, introduza um NIE v&aacute;lido.",
        cifES: "Por favor, introduza um CIF v&aacute;lido."
    });
} else if (pageLanguage == 'es') {
    /*
    * Translated default messages for the jQuery validation plugin.
    * Locale: ES (Spanish; Español)
    */
    $.extend($.validator.messages, {
        required: "Este campo es obligatorio.",
        remote: "Por favor, rellena este campo.",
        email: "Por favor, escribe una dirección de correo válida.",
        url: "Por favor, escribe una URL válida.",
        date: "Por favor, escribe una fecha válida.",
        dateISO: "Por favor, escribe una fecha (ISO) válida.",
        number: "Por favor, escribe un número válido.",
        digits: "Por favor, escribe sólo dígitos.",
        creditcard: "Por favor, escribe un número de tarjeta válido.",
        equalTo: "Por favor, escribe el mismo valor de nuevo.",
        extension: "Por favor, escribe un valor con una extensión aceptada.",
        maxlength: $.validator.format("Por favor, no escribas más de {0} caracteres."),
        minlength: $.validator.format("Por favor, no escribas menos de {0} caracteres."),
        rangelength: $.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
        range: $.validator.format("Por favor, escribe un valor entre {0} y {1}."),
        max: $.validator.format("Por favor, escribe un valor menor o igual a {0}."),
        min: $.validator.format("Por favor, escribe un valor mayor o igual a {0}."),
        nifES: "Por favor, escribe un NIF válido.",
        nieES: "Por favor, escribe un NIE válido.",
        cifES: "Por favor, escribe un CIF válido."
    });
}

jQuery.validator.setDefaults({
    ignore: ":hidden:not(select)",
    errorElement: "span",
    errorClass: "d-block text-danger mt-2"
});

//form validate
$('.form-validate').validate();

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// Comprobar si estamos, al menos, 100 px por debajo de la posición top para mostrar o esconder el botón
$(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
        $('.scroll-to-top').fadeIn();
    } else {
        $('.scroll-to-top').fadeOut();
    }
});
// al hacer click, animar el scroll hacia arriba
$('.scroll-to-top').click(function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 400);
});

//Animación parallax
const parallax = new Parallax('.js-parallax', {
    speed: 0.3, // Anything over 0.5 looks silly
});
parallax.animate();

//Animación de deslizamiento
AOS.init();

//Inicializar tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, {'trigger': 'hover'}));

//Mantener la barra de la cabecera fija al bajar la página
document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener('scroll', function () {
        if (window.scrollY > 200) {
            document.getElementById('navbar_top').classList.add('fixed-top');
            document.getElementById('offcanvasNavbar').classList.add('bottom-auto');
            // add padding top to show content behind navbar
            let navbar_height = document.querySelector('.navbar').offsetHeight;
            document.body.style.paddingTop = navbar_height + 'px';
        } else {
            document.getElementById('navbar_top').classList.remove('fixed-top');
            document.getElementById('offcanvasNavbar').classList.remove('bottom-auto');
            // remove padding top from body
            document.body.style.paddingTop = '0';
        }
    });
});

// multiple with image preview
$("#images").fileinput({
    theme: "fa5",
    language: pageLanguage,
    allowedFileExtensions: ['jpg', 'png'],
    overwriteInitial: false,
    initialPreviewAsData: true,
    maxFileSize: 20000,
    removeFromPreviewOnError: true,
    maxFileCount: 5,
    showCaption: false,
    showRemove: true,
    showUpload: false
});

$("#files").fileinput({
    theme: "fa5",
    language: pageLanguage,
    allowedFileExtensions: ['pdf'],
    overwriteInitial: false,
    initialPreviewAsData: false,
    maxFileSize: 20000,
    removeFromPreviewOnError: true,
    maxFileCount: 5,
    showCaption: false,
    showRemove: true,
    showUpload: false
});

$("#videos").fileinput({
    theme: "fa5",
    language: pageLanguage,
    allowedFileExtensions: ['mp4'],
    overwriteInitial: false,
    initialPreviewAsData: false,
    maxFileSize: 20000,
    removeFromPreviewOnError: true,
    maxFileCount: 1,
    showCaption: false,
    showRemove: true,
    showUpload: false
});

const iconLoading = '<i class="fas fa-cog fa-spin me-1"></i>';
const textLoading = 'Cargando...';

//list images
if ($('#imagesAjax').length) {
    imagesAjax();
}

function imagesAjax() {
    let $this = $('#imagesAjax');
    let $route = $this.data('route');
    $this.html(iconLoading + textLoading);
    $.ajax({
        url: $route,
        method: 'POST'
    }).done(function (response) {
        $this.html(response);
    });
}

//list files
if ($('#filesAjax').length) {
    filesAjax();
}

function filesAjax() {
    let $this = $('#filesAjax');
    let $route = $this.data('route');
    $this.html(iconLoading + textLoading);
    $.ajax({
        url: $route,
        method: 'POST'
    }).done(function (response) {
        $this.html(response);
    });
}

//list videos
if ($('#videosAjax').length) {
    videosAjax();
}

function videosAjax() {
    let $this = $('#videosAjax');
    let $route = $this.data('route');
    $this.html(iconLoading + textLoading);
    $.ajax({
        url: $route,
        method: 'POST'
    }).done(function (response) {
        $this.html(response);
    });
}

//Sortable
$(document).ajaxSuccess(function () {
    // Sortable for elements loaded by ajax
    $(".sortable").each(function () {
        Sortable.create(this, {
            animation: 100,
            handle: ".drag-handle",
            onUpdate: function (evt) {
                let item = $(evt.item); // the current dragged HTMLElement
                let order = item.index() + 1;
                let $route = item.closest('[data-route]').data('route');
                $.ajax({
                    url: $route,
                    type: 'GET',
                    data: {
                        id: item.data("id"),
                        order: order
                    },
                }).fail(function () {
                    alert('Error al ordenar');
                });
            }
        });
    });

    //Inicializar tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, {'trigger': 'hover'}));
});

//Edit name image
$(document.body).on('click', '.edit-image-name', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $route = $this.data('route');
    let $id = $this.data('id');
    let $value = $('#input-image-' + $id).val();
    $this.find('i').removeClass('fa-save').addClass('fa-cog fa-spin');
    $.ajax({
        url: $route,
        method: 'POST',
        data: {name: $value}
    }).done(function () {
        $this.find('i').removeClass('fa-cog fa-spin').addClass('fa-check');
    }).fail(function () {
        alert('Error al renombrar la imagen');
    });
});

//Edit name file
$(document.body).on('click', '.edit-file-name', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $route = $this.data('route');
    let $id = $this.data('id');
    let $value = $('#input-file-' + $id).val();
    $this.find('i').removeClass('fa-save').addClass('fa-cog fa-spin');
    $.ajax({
        url: $route,
        method: 'POST',
        data: {name: $value}
    }).done(function () {
        $this.find('i').removeClass('fa-cog fa-spin').addClass('fa-check');
    }).fail(function () {
        alert('Error al renombrar el fichero');
    });
});

//Edit name video
$(document.body).on('click', '.edit-video-name', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $route = $this.data('route');
    let $id = $this.data('id');
    let $value = $('#input-video-' + $id).val();
    $this.find('i').removeClass('fa-save').addClass('fa-cog fa-spin');
    $.ajax({
        url: $route,
        method: 'POST',
        data: {name: $value}
    }).done(function () {
        $this.find('i').removeClass('fa-cog fa-spin').addClass('fa-check');
    }).fail(function () {
        alert('Error al renombrar el vídeo');
    });
});

//Delete image
$(document.body).on('click', '[data-delete-image]', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $id = $this.data('id');
    let $route = $this.data('route');
    let $confirm = $this.data('confirm');
    if (confirm($confirm)) {
        $('#list-' + $id).remove();
        $.ajax({
            url: $route,
            method: 'POST'
        }).fail(function () {
            alert('Error al eliminar la imagen');
        });
    }
});

//Delete file
$(document.body).on('click', '[data-delete-file]', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $id = $this.data('id');
    let $route = $this.data('route');
    let $confirm = $this.data('confirm');
    if (confirm($confirm)) {
        $('#list-' + $id).remove();
        $.ajax({
            url: $route,
            method: 'POST'
        }).fail(function () {
            alert('Error al eliminar el fichero');
        });
    }
});

//Delete video
$(document.body).on('click', '[data-delete-video]', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $id = $this.data('id');
    let $route = $this.data('route');
    let $confirm = $this.data('confirm');
    if (confirm($confirm)) {
        $('#list-' + $id).remove();
        $.ajax({
            url: $route,
            method: 'POST'
        }).fail(function () {
            alert('Error al eliminar el vídeo');
        });
    }
});

function refreshFiles() {
    if ($('#imagesAjax').length) {
        imagesAjax();
    }
    if ($('#filesAjax').length) {
        filesAjax();
    }
    if ($('#videosAjax').length) {
        videosAjax();
    }
}

// Social links
const popupSize = {
    width: 780,
    height: 550
};

$(document).on('click', '.social-button', function (e) {
    let verticalPos = Math.floor(($(window).width() - popupSize.width) / 2),
        horisontalPos = Math.floor(($(window).height() - popupSize.height) / 2);
    let popup = window.open($(this).prop('href'), 'social',
        'width=' + popupSize.width + ',height=' + popupSize.height +
        ',left=' + verticalPos + ',top=' + horisontalPos +
        ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1');
    if (popup) {
        popup.focus();
        e.preventDefault();
    }
});
